import { useEffect, useState, useCallback } from "react";
import { ReservationSettingsController } from "../../../controllers/reservationSettingsController";
import { ApiUtil } from "../../../util/apiUtil";
import { TableName } from "../../../constants/tableName";
import { ReservationsController } from "../../../controllers/reservationsController";
import { DateUtil } from "../../../util/dateUtil";
import { TableListAvailable } from "../../../components/tableListAvailable";
import { Button } from "react-bootstrap";
import { Loading } from "../../../components/loading";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "../../../components/dropdown";
import { Status } from "../../../constants/status";
import { SlotStatus } from "../../../constants/slotStatus";
import { ReservationSlotSettingsController } from "../../../controllers/reservationSlotSettingsController";

export const AvailablePaxList = ({
  isOpen = false,
  reservationSettingsId,
  reservationType = TableName.NORMALRESERVATIONS,
  backFunction = () => {},
  minDate,
  maxDate,
}) => {
  const navigate = useNavigate();
  const [user] = useState(() => JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(true);
  const [reservations, setReservations] = useState([]);
  const [reservationList, setReservationList] = useState([]);
  const [filteredReservationList, setFilteredReservationList] = useState([]);
  const todayDate = DateUtil.toYYYYMMDDFormat(new Date());
  const [reservationDate, setReservationDate] = useState(todayDate);
  const initialReservationList = {
    reservationDate: todayDate,
    timeSlot: {},
    maxPax: 0,
    activePax: 0,
    availablePax: 0,
    completedPax: 0,
  };
  const [reservationSettings, setReservationSettings] = useState({});
  const getAll = async (reservationSettingsId) => {
    try {
      const reservationSettingData = await new Promise((resolve, reject) => {
        ReservationSettingsController.getViaId({
          id: reservationSettingsId,
          resolve: resolve,
          reject: reject,
        });
      });
      const deserializedReservationSetting = ApiUtil.deserialize({
        data: reservationSettingData,
      });
      setReservationSettings(deserializedReservationSetting);
      const reservationsData = await new Promise((resolve, reject) => {
        ReservationsController.getAllViaTypeAndReservationSettingsId({
          reservationSettingsId,
          type: reservationType,
          resolve: resolve,
          reject: reject,
        });
      });
      setReservations(
        ApiUtil.deserialize({
          data: reservationsData,
        })
      );
    } catch (error) {
      console.error("Error loading reservation data:", error);
    } finally {
      setLoading(false);
    }
  };
  const groupReservation = async () => {
    const dateList = [];
    let currentDate = new Date(minDate);
    const timeSlotsList =
      reservationType === TableName.NORMALRESERVATIONS
        ? reservationSettings?.normalSettings?.timeSlotsList
        : reservationSettings?.eventSettings?.timeSlotsList;
    const allSlotStatusSettings = ApiUtil.deserialize({
      data: await getAllSlotStatusSettings(),
    });
    while (currentDate <= new Date(maxDate)) {
      timeSlotsList?.forEach((timeSlot) => {
        const reservationDate = DateUtil.toYYYYMMDDFormat(
          new Date(currentDate)
        );
        const activePax = getCount(timeSlot.id, reservationDate, Status.ACTIVE);
        const completedPax = getCount(
          timeSlot.id,
          reservationDate,
          Status.COMPLETED
        );
        const cancelledPax = getCount(
          timeSlot.id,
          reservationDate,
          Status.CANCELLED
        );
        const newSlotStatusList = allSlotStatusSettings.filter(
          (data) =>
            data.reservationDate === reservationDate &&
            data.timeSlot.id === timeSlot.id
        );
        dateList.push({
          ...initialReservationList,
          reservationDate,
          id: timeSlot.id,
          slotTitle: timeSlot.slotTitle,
          timeSlot,
          maxPax: timeSlot.maxPax,
          activePax,
          availablePax: timeSlot.maxPax - activePax - completedPax,
          completedPax,
          cancelledPax,
          status:
            newSlotStatusList.length > 0
              ? `*${SlotStatus.getStatusValue(
                  newSlotStatusList[0]?.timeSlot?.newSlotStatus
                )}`
              : getCalculatedSlotStatus(timeSlot, activePax, completedPax),
        });
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }
    setReservationList(dateList);
    setFilteredReservationList(
      dateList.filter((list) => list.reservationDate === reservationDate)
    );
  };
  const getAllSlotStatusSettings = () => {
    return new Promise((resolve, reject) => {
      ReservationSlotSettingsController.getAllNewSlotStatus({
        type:
          reservationType === TableName.NORMALRESERVATIONS
            ? TableName.NORMALRESERVATIONSLOTSETTINGS
            : TableName.EVENTRESERVATIONSLOTSETTINGS,
        reservationSettingsId: reservationSettingsId,
        reservationDate: reservationDate,
        resolve: resolve,
        reject: reject,
      });
    });
  };
  const getCalculatedSlotStatus = (timeSlot, activePax, completedPax) => {
    return new Date(reservationDate) >= new Date(todayDate)
      ? SlotStatus.getStatusValue(
          activePax + completedPax >= timeSlot.maxPax
            ? SlotStatus.FULLYBOOKED
            : activePax + completedPax >= Math.ceil(timeSlot.maxPax / 2)
            ? SlotStatus.LIMITEDQUANTITY
            : timeSlot.slotStatus
        )
      : Status.getStatusValue(Status.COMPLETED);
  };
  const getCount = (timeSlotId, reservationDate, status) => {
    let count = 0;
    const filteredSlots = reservations.filter(
      (data) =>
        data.timeSlot.id === timeSlotId &&
        data.reservationDate === reservationDate &&
        data.status === status
    );
    filteredSlots.forEach((data) => {
      count += data.pax;
    });
    return count;
  };
  const handleOnChange = useCallback(
    (value) => {
      setReservationDate(value);
      setFilteredReservationList(
        value
          ? reservationList.filter((list) => list.reservationDate === value)
          : reservationList
      );
    },
    [reservationList]
  );
  const generateDateOptions = (startDate, endDate) => {
    if (reservationType === TableName.NORMALRESERVATIONS) {
      const options = [];
      for (
        let currentDate = new Date(startDate);
        currentDate <= new Date(endDate);
        currentDate.setDate(currentDate.getDate() + 1)
      ) {
        const dateString = currentDate.toISOString().split("T")[0];
        options.push({ value: dateString, label: dateString });
      }
      return options;
    }
    return (
      reservationSettings?.eventSettings?.timeSlotsList?.map((data) => {
        const eventDate = new Date(data.eventDate).toISOString().split("T")[0];
        return { value: eventDate, label: eventDate };
      }) || []
    );
  };
  useEffect(() => {
    getAll(reservationSettingsId);
  }, []);
  useEffect(() => {
    if (!user) navigate("/loginSignUp", { state: { isLoginToggle: true } });
  }, [user]);
  useEffect(() => {
    if (
      isOpen &&
      reservationSettingsId &&
      reservationType &&
      minDate &&
      maxDate
    ) {
      setLoading(false);
    }
  }, [isOpen, reservationSettingsId, reservationType, minDate, maxDate]);
  useEffect(() => {
    if (reservationType === TableName.NORMALRESERVATIONS) {
      if (
        reservationSettings?.normalSettings?.timeSlotsList &&
        reservations.length > 0
      )
        groupReservation();
    } else {
      if (
        reservationSettings?.eventSettings?.timeSlotsList &&
        reservations.length > 0
      )
        groupReservation();
    }
  }, [reservationSettings, reservations, reservationDate]);
  useEffect(() => {
    if (reservationType === TableName.EVENTRESERVATIONS) {
      const firstEventDate =
        reservationSettings?.eventSettings?.timeSlotsList?.[0]?.eventDate;
      if (firstEventDate) {
        setReservationDate(firstEventDate);
      }
    }
  }, [reservationSettings, reservationType]);

  return loading ? (
    <Loading />
  ) : (
    <section id="availablePaxList">
      <div className="reservation-container">
        <h3>{`AVAILABLE ${
          reservationType === TableName.NORMALRESERVATIONS ? "NORMAL" : "EVENT"
        } PAX LIST`}</h3>
        <hr />
        <form className="margin-bottom">
          <Dropdown
            name="reservationDate"
            title="Reservation Date"
            value={reservationDate}
            options={generateDateOptions(minDate, maxDate)}
            isClearable={false}
            onChangeFunc={handleOnChange}
            isMandatory={false}
            placeholder="All"
          />
          <TableListAvailable
            list={filteredReservationList}
            rowsPerPage={
              reservationType === TableName.NORMALRESERVATIONS
                ? reservationSettings?.normalSettings?.timeSlotsList?.length
                : reservationSettings?.eventSettings?.timeSlotsList?.length
            }
          />
        </form>
      </div>
      <div className="button-container stick-bottom">
        <Button onClick={backFunction}>BACK</Button>
        <Button
          onClick={() => getAll(reservationSettingsId)}
          className="arrow-button"
        >
          REFRESH
        </Button>
      </div>
    </section>
  );
};
